import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "<insert deity> bless opensource",
  "description": "",
  "published": "2008-07-09T00:00:00.000Z",
  "redirect_from": ["/blog/ltinsert-deitygt-bless-opensource/swizec/96"],
  "categories": "food for thought, intrigues, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There has been `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=297"
      }}>{`blabber about opensource`}</a>{` around here before and some `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=226"
      }}>{`against`}</a>{` but what there hasn't been is an ode and an ode is exactly what opensource needs right now. Because it's fucking awesome! And why exactly would that be, just why is this opensource thing so very awesome, you might ask. Well stop fussing around and let me tell you a tale, a tale of labour cut to a minimum, a tale of espionage and treasure, and most of all bare-breasted cuties.`}</p>
    <p>{`A few months ago I was told about a project wherein a social network thingy much like facebook would have to be made for students of Europe and their teachers, alright I thought, gave a rough time estimate and forgot about it. Then last week the project, after hassling around with the clients and whatnot the project came back. This time I made another time estimate - roughly two hundred hours.`}</p>
    <p><em parentName="p">{`Whoa`}</em>{` everyone thought, the programmer has his work cut out, we can reel the designer in a bit later and we all have very much time left on our hands. Then I did some searching because verily some opensource alternative to me doing all the work was about and I'd merely have to touch it up a bit. What I found was `}<a parentName="p" {...{
        "href": "http://elgg.org/"
      }}>{`elgg`}</a>{` ... a totally and absolutely complete social networking thingy that has `}<em parentName="p">{`everything`}</em>{` absolutely `}<strong parentName="p">{`everything`}</strong>{` we needed either built in or as a freely available plugin.`}</p>
    <p>{`Now you may not fully understand the situation here so let me boil it down for you. The time estimate for my work plumeted from ~200 hours to `}<strong parentName="p">{`~50 hours`}</strong>{`!! FIFTY! ... I did in two hours what I thought would take me `}<em parentName="p">{`three weeks`}</em>{`! (the left-over 50 hours are for aplying the fancy design). But don't you dare think I stole anything, I intend to give full credit to the developers of elgg and if we decide a funky plugin is needed for some special feature we come up with I have all intention (and permission from the boss) to give it back to the elgg community.`}</p>
    <p>{`Ok so there were no bare-breasted cuties in this story, but what there was was so much more awesome you can't blame me for skipping the boobies.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      